import {environment} from '../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root' // Cela garantit que Angular sait comment fournir ce service
})

export class Endpoints {
    private baseUrl = environment.base_url;

    // Authentication
    public login = this.baseUrl + '/api/auth/signin';

    // Manage Samplers
    public sampler_base_endpoint = this.baseUrl + '/api/samples';
    public fiche_paillasse_base_endpoint = this.baseUrl + '/api/fichePaillasse';
    public user_base_endpoint = this.baseUrl + '/api/users';
    public methode_base_endpoint = this.baseUrl + '/api/methodes';
    public departemet_base_endpoint = this.baseUrl + '/api/departments';
    public client_base_endpoint = this.baseUrl + '/api/clients';
    public ai_base_endpoint = this.baseUrl + '/api/analyse-instrumentale';
    public methodeA_base_endpoint = this.baseUrl + '/api/methode-instrumentale';
    public batchA_base_endpoint = this.baseUrl + '/api/batch-analytique';
    public client_poc_base_endpoint = this.baseUrl + '/api/pocs';
    public client_terrain_base_endpoint = this.baseUrl + '/api/terrain';
    public client_exploitation_base_endpoint = this.baseUrl + '/api/exploitations';
    public matrice_base_endpoint  = this.baseUrl + '/api/matrices';
    public laboratory_base_endpoint = this.baseUrl + '/api/labo';
    public task_base_endpoint = this.baseUrl +'/api/tasks';
    public methodeS_base_endpoint = this.baseUrl +'/api/method-steps';
    public analyseR_base_endpoint = this.baseUrl +'/api/analyse-result';
    public sample_status_base_endpoint = this.baseUrl + '/api/sampleStatus';
    public type_analyse_base_endpoint = this.baseUrl + '/api/typeAnalyses';
    public parametres_base_endpoint = this.baseUrl + '/api/Parameters';
    public analyse_base_endpoint = this.baseUrl + '/api/analyses';
    public batch_base_endpoint = this.baseUrl + '/api/batch';

    public parametre_base_endpoint = this.baseUrl + '/api/parametres';


    public results_base_endpoint = this.baseUrl + '/api/results';
    public rapport_endpoint = this.baseUrl + '/api/rapports';
    public devis_endpoint = this.baseUrl + '/api/devis';


    public sample_base_endpoint = this.baseUrl + '/api/samples';
    public samples_by_client_id_endpoint = `${this.sample_base_endpoint}/findAllByClientId`;
    public user_endpoint_create = this.baseUrl + '/api/users/create_users';
    public user_endpoint = this.baseUrl + '/api/users';

    public chat_endpoint = this.baseUrl + '/api/chat';
    public acc_endpoint = this.baseUrl + '/api/accreditations';

    public labo_endpoint = this.baseUrl + '/api/labo';

    public formule_base_endpoint = this.baseUrl + '/api/formule';


}
